import { render } from "./TopBarBackImage.vue?vue&type=template&id=1a2413b4"
import script from "./TopBarBackImage.vue?vue&type=script&lang=js"
export * from "./TopBarBackImage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__